import { useFormik } from "formik";
import { useState } from "react";
import * as Yup from "yup";
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";
import { toast } from "react-toastify";
import { handleAuthError, isAuthError } from "../utils/handleAuthError";

export default function useSupportFormik() {
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .min(2, "El nombre debe tener al menos 2 caracteres")
      .required("El nombre es obligatorio"),
    email: Yup.string()
      .email("Correo inválido")
      .required("El correo es obligatorio"),
    subject: Yup.string()
      .min(3, "El asunto debe tener al menos 3 caracteres")
      .required("El asunto es obligatorio"),
    message: Yup.string()
      .min(10, "El mensaje debe tener al menos 10 caracteres")
      .required("El mensaje es obligatorio"),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      subject: "Reporte de problema - Boxplus",
      message: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true);

      try {
        const sendSupportEmail = httpsCallable(
          functions,
          "sendSupportEmail"
        );
        
        await sendSupportEmail({
          name: values.name,
          email: values.email,
          subject: values.subject,
          message: values.message,
        });
        
        toast.success("Reporte enviado exitosamente. Nos pondremos en contacto contigo pronto.");
        
        // Resetear el formulario después de enviar
        formik.resetForm();
      } catch (err: unknown) {
        if (isAuthError(err)) {
          handleAuthError();
          return;
        }
        console.error({ err });
        let errorMessage = "Ocurrió un error al enviar el reporte";
        
        if ((err as Error)?.message) {
          errorMessage = (err as Error).message;
        }
        
        toast.error(errorMessage);
      } finally {
        setLoading(false);
      }
    },
  });

  return { ...formik, loading };
}

